import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import AccessTimeIcon from "@mui/icons-material/AccessTime";

interface GoalIconProps {
    bgcolor?: string;
    title: string;
}

const GoalIcon = (props: GoalIconProps) => (
    <Box
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 2,
            ml: 2,
        }}
    >
        <AccessTimeIcon sx={{ fontSize: "1em", color: "#85CC6D" }} />
        <Typography
            variant="h6"
            sx={{
                fontWeight: "bold",
                ml: 1,
            }}
        >
            {props.title}
        </Typography>
    </Box>
);

export default GoalIcon;
